import React, { useEffect, useState } from "react";
import "./Hero.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Carousel from "react-bootstrap/Carousel";
import Button from "react-bootstrap/Button";
// Import Images
import Logo1 from "../../assets/logo1.png";

const Hero = () => {
  const [fontSize, setFontSize] = useState("fs-1");
  const [buttonClass, setButtonClass] = useState("fs-4");
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 1025) {
        setFontSize("fs-3");
      } else if (window.innerWidth <= 1220) {
        setFontSize("fs-2");
      } else {
        setFontSize("fs-1");
      }

      if (window.innerWidth < 376) {
        setButtonClass("fs-5");
      } else if (window.innerWidth <= 321) {
        setButtonClass("fs-6");
      } else {
        setButtonClass("fs-4");
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize(); // Llama a handleResize al cargar la página para establecer el tamaño de fuente inicial

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <Container
        fluid
        className="text-center container-hero d-flex align-items-center justify-content-center"
      >
        <Row className="align-items-center justify-content-center grid-h no-padding">
          <Col>
            <img
              src={Logo1}
              className="img-logo"
              alt="Logo de Revision Automotriz"
            />
          </Col>
          <Col className="d-flex flex-column align-items-center justify-content-center right-h ps-4 pe-4">
            <Carousel
              controls={true}
              indicators={false}
              touch={true}
              className="container-h"
            >
              <Carousel.Item interval={5000}>
                <div className="d-flex flex-column align-items-center justify-content-center">
                  <h1
                    className={`${fontSize} mx-5 text-light fw-bolder title-h`}
                  >
                    ¿COMPRAS UN USADO?
                  </h1>
                </div>
              </Carousel.Item>
              <Carousel.Item interval={5000}>
                <div className="d-flex flex-column align-items-center justify-content-center">
                  <h2
                    className={`${fontSize} mx-5 text-light fw-bolder title-h`}
                  >
                    COMPRA CON SEGURIDAD
                  </h2>
                </div>
              </Carousel.Item>
              <Carousel.Item interval={5000}>
                <div className="d-flex flex-column align-items-center justify-content-center">
                  <h2
                    className={`${fontSize} mx-5 text-light fw-bolder title-h`}
                  >
                    NO COMPRES A CIEGAS
                  </h2>
                </div>
              </Carousel.Item>
            </Carousel>
            <div className="d-flex justify-content-center align-items-center flex-column">
              <p className="pt-1 pb-1 ps-2 pe-2 mt-1 sub-title-h text-light fw-bold fs-5">
                REVISIÓN PRE-COMPRA
              </p>
              <p className="pt-1 pb-1 text-dark fs-4 fw-bold text-center">
                ELIGE TU VEHÍCULO, NOSOTROS TE LO REVISAMOS
              </p>
              <Button
                size="sm"
                className={`btn-h mt-3 mb-3 pt-2 ps-4 pe-4 fw-bold ${buttonClass}`}
                href="https://wa.me/+59893961919"
                target="_blank"
              >
                COMPRÁ CON SEGURIDAD
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Hero;
